import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateService } from '@services/app-state.service';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LiteratureAPIMAPIService {
  constructor(
    private httpClient: HttpClient,
    private appStateService: AppStateService,
    private cookieService: CookieService
  ) {}

  postWithToken(
    APIMKeyType: string,
    url: string,
    requestPayLoad: any = null,
    customRequestHeaders: any = null
  ): Observable<any> {
    return this.httpClient.post<Observable<any>>(
      url,
      requestPayLoad,
      this.getHttpOptions(APIMKeyType, customRequestHeaders)
    );
  }

  postWithTokenAndCustomOptions(
    APIMKeyType: string,
    url: string,
    requestPayLoad: any = null,
    customRequestOptions: any = null,
    setAdditionalHeader: any = null
  ) {
    const authToken = this.getAuthToken();
    const literatureAPIMKey =
      APIMKeyType === 'nonAuth'
        ? this.appStateService.getLiteratureAPIMKey()
        : this.appStateService.getLiteratureAuthAPIAPIMKey();
    const requestHeaders = {
      'X-FT-API-KEY': `${literatureAPIMKey}`,
      'Content-Type': 'application/json',
      Authorization: authToken ? `Bearer ${authToken}` : '',
    };
    customRequestOptions.headers = new HttpHeaders({
      ...requestHeaders,
      ...setAdditionalHeader,
    });

    return this.httpClient.post<Observable<any>>(
      url,
      requestPayLoad,
      customRequestOptions
    );
  }

  getWithToken(
    APIMKeyType: string,
    url: string,
    customRequestHeaders: any = null
  ): Observable<any> {
    return this.httpClient.get<Observable<any>>(
      url,
      this.getHttpOptions(APIMKeyType, customRequestHeaders)
    );
  }

  private getHttpOptions(APIMKeyType: string, customRequestHeaders: any) {
    const authToken = this.getAuthToken();
    const literatureAPIMKey =
      APIMKeyType === 'auth'
        ? this.appStateService.getLiteratureAuthAPIAPIMKey()
        : this.appStateService.getLiteratureAPIMKey();
    const requestHeaders = {
      'X-FT-API-KEY': `${literatureAPIMKey}`,
      'Content-Type': 'application/json',
      Authorization: authToken ? `Bearer ${authToken}` : '',
    };
    const httpOptions = {
      headers: new HttpHeaders({ ...requestHeaders, ...customRequestHeaders }),
    };
    return httpOptions;
  }

  private getAuthToken(): string {
    return this.cookieService.get('OAUTH_TOKEN_COOKIE');
  }
}
